import React from "react"
import BgIcon from "../../../images/bg-icon.svg"
import BgIconBlack from "../../../images/bg-icon-black.svg"
import MethodologyImg from "../../../images/metodology.svg"
import ToolsImg from "../../../images/tools.svg"

const AvailableRoles = () => {
  return (
    <>
      <section className="bg-neutral">
        <div className="container mx-auto px-6 py-20">
          <h3 className="text-5xl font-bold pb-8 leading-snug">
            <span className="text-secondary font-bold block leading-tight">
              Available
            </span>
            profiles
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 pb-6">
            <div className="flex flex-row items-center">
              <div
                className="text-white mr-2 w-20 h-20 bg-no-repeat bg-center flex content-center items-center justify-center font-medium text-2xl"
                style={{ backgroundImage: `url(${BgIcon})` }}
              >
                PM
              </div>
              <h5 className="text-2xl">Project Managers</h5>
            </div>

            <div className="flex flex-row items-center">
              <div
                className="text-white mr-2 w-20 h-20 bg-no-repeat bg-center flex content-center items-center justify-center font-medium text-2xl"
                style={{ backgroundImage: `url(${BgIcon})` }}
              >
                TL
              </div>
              <h5 className="text-2xl">Technical leads</h5>
            </div>

            <div className="flex flex-row items-center">
              <div
                className="text-white mr-2 w-20 h-20 bg-no-repeat bg-center flex content-center items-center justify-center font-medium text-2xl"
                style={{ backgroundImage: `url(${BgIcon})` }}
              >
                BA
              </div>
              <h5 className="text-2xl">Business Analysts</h5>
            </div>

            <div className="flex flex-row items-center">
              <div
                className="text-white mr-2 w-20 h-20 bg-no-repeat bg-center flex content-center items-center justify-center font-medium text-2xl"
                style={{ backgroundImage: `url(${BgIcon})` }}
              >
                DE
              </div>
              <h5 className="text-2xl">Devops engineers</h5>
            </div>

            <div className="flex flex-row items-center">
              <div
                className="text-white w-20 h-20 bg-no-repeat bg-center flex content-center items-center justify-center font-medium text-2xl"
                style={{ backgroundImage: `url(${BgIcon})` }}
              >
                FE
              </div>
              <h5 className="text-2xl pl-2">Front-end engineers</h5>
            </div>

            <div className="flex flex-row items-center">
              <div
                className="text-white mr-2 w-20 h-20 bg-no-repeat bg-center flex content-center items-center justify-center font-medium text-2xl"
                style={{ backgroundImage: `url(${BgIcon})` }}
              >
                BE
              </div>
              <h5 className="text-2xl">Back-end engineers</h5>
            </div>

            <div className="flex flex-row items-center">
              <div
                className="text-white mr-2 w-20 h-20 bg-no-repeat bg-center flex content-center items-center justify-center font-medium text-2xl"
                style={{ backgroundImage: `url(${BgIcon})` }}
              >
                FS
              </div>
              <h5 className="text-2xl">Full-stack engineers</h5>
            </div>

            <div className="flex flex-row items-center">
              <div
                className="text-white mr-2 w-20 h-20 bg-no-repeat bg-center flex content-center items-center justify-center font-medium text-2xl"
                style={{ backgroundImage: `url(${BgIcon})` }}
              >
                UX
              </div>
              <h5 className="text-2xl">UI/UX designers</h5>
            </div>
          </div>
        </div>
      </section>
      <section className="container mx-auto px-6 py-20">
        <div className="flex flex-col lg:flex-row items-center">
          <div className="w-full lg:w-1/4 lg:pr-8">
            <h3 className="text-5xl font-bold pb-8 leading-snug text-left lg:text-right">
              <span className="text-secondary font-bold block">Roles</span> &
              Squad
            </h3>
          </div>
          <div className="w-full lg:w-3/4">
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8 pb-6">
              <div className="flex flex-row items-center justify-end">
                <h5 className="text-2xl text-right">Delivery Manager</h5>
                <div
                  className="text-white ml-2 w-28 h-20 bg-no-repeat bg-center flex content-center items-center justify-center font-medium text-2xl"
                  style={{ backgroundImage: `url(${BgIconBlack})` }}
                >
                  DM
                </div>
              </div>
              <div className="flex flex-row items-center justify-end">
                <h5 className="text-2xl text-right">Funcional Analyst</h5>
                <div
                  className="text-white ml-2 w-28 h-20 bg-no-repeat bg-center flex content-center items-center justify-center font-medium text-2xl"
                  style={{ backgroundImage: `url(${BgIconBlack})` }}
                >
                  FA
                </div>
              </div>
              <div className="flex flex-row items-center justify-end">
                <h5 className="text-2xl text-right">Testing & QA</h5>
                <div
                  className="text-white ml-2 w-28 h-20 bg-no-repeat bg-center flex content-center items-center justify-center font-medium text-2xl"
                  style={{ backgroundImage: `url(${BgIconBlack})` }}
                >
                  QA
                </div>
              </div>
              <div className="flex flex-row items-center justify-end">
                <h5 className="text-2xl text-right">UI/UX Designers</h5>
                <div
                  className="text-white ml-2 w-28 h-20 bg-no-repeat bg-center flex content-center items-center justify-center font-medium text-2xl"
                  style={{ backgroundImage: `url(${BgIconBlack})` }}
                >
                  UX
                </div>
              </div>
              <div className="flex flex-row items-center justify-end">
                <h5 className="text-2xl text-right">Front-end Development</h5>
                <div
                  className="text-white ml-2 w-28 h-20 bg-no-repeat bg-center flex content-center items-center justify-center font-medium text-2xl"
                  style={{ backgroundImage: `url(${BgIconBlack})` }}
                >
                  FE
                </div>
              </div>
              <div className="flex flex-row items-center justify-end">
                <h5 className="text-2xl text-right">Back-end Development</h5>
                <div
                  className="text-white ml-2 w-28 h-20 bg-no-repeat bg-center flex content-center items-center justify-center font-medium text-2xl"
                  style={{ backgroundImage: `url(${BgIconBlack})` }}
                >
                  BE
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="bg-primary text-white py-20">
        <div className="px-6 container mx-auto">
          <div className="flex flex-col md:flex-row items-center pb-20">
            <div className="w-full md:w-1/2">
              <h3 className="text-5xl font-bold pb-8">
                <span className="text-secondary font-bold block leading-tight">
                  Our
                </span>
                methodologies 
              </h3>
              <div className="font-medium grid grid-cols-2 gap-5 text-3xl py-8">
                <div>Scrum</div>
                <div className="text-secondary">Kanban</div>
                <div className="text-secondary">Design thinking</div>
                <div>Design Sprint</div>
              </div>
            </div>
            <div className="w-full md:w-1/2">
              <img
                src={MethodologyImg}
                alt="Our Methodology"
                className="mx-auto"
              />
            </div>
          </div>
          <div className="flex flex-col-reverse md:flex-row items-center">
            <div className="w-full md:w-1/2">
              <img src={ToolsImg} alt="Our Tools" className="mx-auto" />
            </div>
            <div className="w-full md:w-1/2">
              <h3 className="text-5xl font-bold pb-8">
                <span className="text-secondary font-bold block leading-tight">
                  Our
                </span>
                Tools
              </h3>
              <div className="font-medium grid grid-cols-2 gap-8 text-3xl py-8">
                <div className="text-secondary">Roadmap</div>
                <div>Mind map</div>
                <div>Rapid ideation</div>
                <div className="text-secondary">Brain storming</div>
                <div className="text-secondary">User story</div>
                <div>Flow chart</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default AvailableRoles
